import styled from 'styled-components';

// Standard Button
export const StyledStandardButton = styled.button<{background?: string; disabled?: boolean; margin?: string}>`
    background: ${props => props.disabled? '#888888' : props.background};
    color: #FFFFFF;
    border: 0;
    height: 35px;
    padding: 0 15px;
    margin: ${props => props.margin? props.margin : '0 10px' };
    font-size: 16px;
    border-radius: 35px;
    cursor: pointer;
`;

